import React, {useEffect, useRef, useState} from 'react';
import PaynowBanner from "../../../assets/images/paynow/Paynow Badge-vector-hires LIGHT.svg"
import PaynowButton from "../../../assets/images/paynow/button_make-payment_large.svg"
import {Button} from 'primereact/button';
import AppCard from '../../../components/ui/AppCard';
import paymentImage from "../../../assets/images/patterns/payments-bg.png"
import {Dialog} from 'primereact/dialog';
import AnimatedSuccessGIF from '../../../assets/images/check-green.gif'
import AnimatedWarningGIF from '../../../assets/images/warning.gif'
import {Link, useHistory} from 'react-router-dom';
import {Toast} from 'primereact/toast';
import apiClient from "../../../services/api-client";
import {ProgressSpinner} from 'primereact/progressspinner';
import {Messages} from 'primereact/messages';
import PaymentForm from "./components/PaymentForm"
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../utils/storage-helper';
import RecurringPaymentsDialog from "./components/RecurringPaymentsDialog";
import AppConfirmDialog from "../../../components/ui/AppConfirmDialog";

// .replace(...) strips any trailing slash(es) from REACT_APP_DOVESAPI so concatenating with
// threeDsInitUrl (which already starts with "/") below never produces "http://host//path" --
// a double slash there fails Spring Security's exact-path matcher for /visa-3ds-init.html and
// falls through to .anyRequest().authenticated(), which is what was producing the 403.
const DOVES_API_BASE = (() => {
  let base = process.env.REACT_APP_DOVESAPI || '';
  while (base.endsWith('/')) base = base.slice(0, -1);
  return base;
})();

// The 3-D Secure iframe is served by the Doves API, so only messages from its origin are trusted.
const DOVES_API_ORIGIN = (() => {
  try {
    return new URL(DOVES_API_BASE, window.location.origin).origin;
  } catch (e) {
    return window.location.origin;
  }
})();

function ReceivedFailure({serverResponse}) {
    const history = useHistory();

    return <center>
            <div className=" text-center my-4">
                <img width="100px" src={AnimatedWarningGIF} alt=""/>
            </div>

            <h3>Payment failed to process</h3>
            {serverResponse && <p><strong>Failure Reason : </strong>{serverResponse.message}</p>}
            <p>You payment could not be processed</p>
            <Button
                onClick={() => {
                    history.push("/")
                }}
                className="btn btn-info text-white justify-content-center text-center m-2"
                size='large'
                label='Ok'
                icon="pi pi-check-circle"
                severity="info"
                rounded
                raised
                style={{color: "white"}} // Add this style to set the button text color
            />

        </center>;
}

function ReceivedSuccess({serverResponse, onClose}) {
    const details = serverResponse?.responseBody ? serverResponse.responseBody : serverResponse;

    return <div className="flex flex-col items-center justify-center p-6 text-center">
            <div className="mb-6 flex items-center justify-center">
                <img className="w-24 h-24 object-contain" src={AnimatedSuccessGIF} alt="Success"/>
            </div>

            <h3 className="text-2xl font-bold text-base-content mb-2">Payment Successful</h3>
            {details && <p className="text-base-content/80 mb-1">Your payment reference is: <strong
                className="text-base-content">{details.paymentReference || '-'}</strong></p>}
            <p className="text-base-content/80 mb-8">You have successfully made a payment to your policy.</p>

            <button
                onClick={onClose}
                className="btn btn-success text-white rounded-full px-12 shadow-sm"
            >
                <i className="pi pi-check-circle text-lg mr-2"></i> Close
            </button>
        </div>;
}

function SubmittedRequest({paymentMethod, serverResponse, seconds_left}) {

    return <center>
            <h3>You will receive a prompt to input your security pin on your phone</h3>
            <p>Kindly authorise your {paymentMethod} payment on your phone number.</p>
            {serverResponse && <p>Your payment reference is
                : <strong>{serverResponse.responseBody.paymentReference}</strong></p>}
            {serverResponse && <p><strong>Your payment poll verification link : </strong><Link
                to={serverResponse.responseBody.pollUrl}>{serverResponse.responseBody.pollUrl}</Link></p>}
            {serverResponse && <p>{serverResponse.responseBody.paymentInstructions}</p>}
            <div className=" text-center my-4">
                <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8"
                                 fill="var(--surface-ground)" animationDuration=".5s"/>
                <h5>will automatically verify in ({seconds_left})second</h5>
            </div>

        </center>;
}

function VerifyRequest({serverResponse, onCancel, onRetry}) {
    return <center>
            <h3>Confirm payment status</h3>
            <p>We are verifying your payment.</p>
            <div className=" text-center my-4">
                <h5>Your payment has not been verified</h5>
                {serverResponse && <p>Your payment reference is
                    : <strong>{serverResponse.responseBody.paymentReference}</strong></p>}
                {serverResponse && <p><strong>Your payment poll verification link : </strong><Link
                    to={serverResponse.responseBody.pollUrl}>{serverResponse.responseBody.pollUrl}</Link></p>}
                {serverResponse && <p>{serverResponse.responseBody.paymentInstructions}</p>}
            </div>
            <div className='row'>
                <div className='justify-content-center'>

                    <Button
                        onClick={onCancel}
                        className="btn btn-primary btn-outline justify-content-center text-center m-2"
                        size='large'
                        label='Cancel Payment'
                        icon="pi pi-times"
                        severity="primary"
                        rounded
                        outlined
                        raised
                        // Add this style to set the button text color
                    />
                    <Button
                        onClick={onRetry}
                        className="btn btn-info btn-outline justify-content-center text-center m-2"
                        size='large'
                        label='Retry Verification'
                        icon="pi pi-refresh"
                        severity="info"
                        rounded
                        outlined
                        raised
                    />
                </div>
            </div>

        </center>;
}

// The 3-D Secure step: an iframe pointed at the backend's static init page, running inside
// this same Dialog. That page fetches its own session fields, shows the policy number and
// monthly premium readonly, and auto-submits to iVeri -- the rest of the ceremony (device
// fingerprint, possible challenge) plays out inside this iframe until iVeri redirects back to
// our backend, which posts the final result up via window.parent.postMessage (handled above).
function ThreeDsFrame({threeDsInitUrl}) {
    return <>
        <center>
            <h3>Secure Card Verification</h3>
            <p>We've opened a secure payment tab for you to complete verification. You can also finish it below.</p>
            <div className="mb-4 mt-2">
                <button
                    type="button"
                    className="btn btn-outline btn-primary w-full max-w-sm"
                    onClick={() => {
                        window.open(threeDsInitUrl, '_blank');
                    }}
                >
                    <i className="pi pi-external-link mr-2"></i> Reopen in New Tab
                </button>
                <p className="text-xs text-slate-500 mt-2">If the new tab didn't open (your browser may have blocked it) or the page below is blank, use the button above.</p>
            </div>
        </center>
        <iframe
            title="3D Secure Verification"
            src={threeDsInitUrl || 'about:blank'}
            style={{width: '100%', height: '600px', border: 'none'}}
        />
    </>;
}

function MakePayment({balanceFormatted, policyNumberCurrentUser, phoneNumberCurrentUser}) {
    const [isPaymentDialogVisible, setIsPaymentDialogVisible] = useState(false);
    const [isRecurringDialogVisible, setIsRecurringDialogVisible] = useState(false);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(phoneNumberCurrentUser);
    const [policyNumber, setPolicyNumber] = useState(policyNumberCurrentUser);
    const [paymentNotes, setPaymentNotes] = useState("");
    const [amount, setAmount] = useState(balanceFormatted);
    const [initialmount] = useState(balanceFormatted);
    const [paymentMethods] = useState(["Ecocash", "Pay using Paynow", "Pay with Visa Card"])
    const [paymentMethod, setPaymentMethod] = useState("")
    const [cardNumber, setCardNumber] = useState("");
    const [expiryMonth, setExpiryMonth] = useState("");
    const [expiryYear, setExpiryYear] = useState("");
    const [cvv, setCvv] = useState("");
    const [cardHolderName, setCardHolderName] = useState("");
    const [setRecurring, setSetRecurring] = useState(true);
    const toast = useRef(null);
    const msgs = useRef(null);
    const [activeView, setActiveView] = useState(0);
    let userProfile = {};
    const [seconds_left, setSeconds_left] = useState(30);
    const [serverResponse, setServerResponse] = useState({});
    const [threeDsInitUrl, setThreeDsInitUrl] = useState(null);
    const setisPaymentDialogVisibleCheck = (value) => {
        if (isPaymentLoading) {
            toast.current.show({
                severity: 'warn',
                summary: 'Processing Payment',
                detail: 'You cannot close this dialog while your payment is processing',
                life: 3000
            });
        } else {
            setIsPaymentDialogVisible(value);
        }

    }

    const submitPaymentRequest = (e) => {
        e.preventDefault();

        if (paymentMethod === "Pay with Visa Card") {
            setIsPaymentLoading(true)
            confirm()
            return;
        }

        // Perform your custom form validation logic
        const isFormValid =
            paymentMethod !== "" &&
            phoneNumber !== "" &&
            amount >= balanceFormatted &&
            policyNumber !== ""

        ;
        if (isFormValid) {
            setIsPaymentLoading(true)
            confirm()
        } else {

            // msgs.current.show(
            //   { sticky: false, severity: 'warn', detail: 'Please fill in the required fields.'+ '\n\n'+'Make sure your payment amount is equal or greater than your current balance $'+ balanceFormatted, closable: true }
            // );
            toast.current.show({
                severity: 'warn',
                summary: 'Make Payment' + (amount >= balanceFormatted),
                detail: 'Please fill in the required fields.\n\nMake sure your payment amount is equal or greater than your current balance $' + balanceFormatted,
                life: 9000
            });

        }

    }

    const viewList = [
        <PaymentForm
            key="PaymentForm"
            paymentMethods={paymentMethods}
            paymentMethod={paymentMethod}
            phoneNumber={phoneNumber}
            amount={amount}
            initialAmount={initialmount}
            policyNumber={policyNumber}
            paymentNotes={paymentNotes}
            cardNumber={cardNumber}
            expiryMonth={expiryMonth}
            expiryYear={expiryYear}
            cvv={cvv}
            cardHolderName={cardHolderName}
            handlePaymentMethodChange={(e) => setPaymentMethod(e)}
            handlePhoneNumberChange={(e) => setPhoneNumber(e.target.value)}
            handleAmountChange={(e) => setAmount(e)}
            handlePolicyNumberChange={(e) => setPolicyNumber(e.target.value)}
            handlePaymentNotesChange={(e) => setPaymentNotes(e.target.value)}
            handleCardNumberChange={(e) => setCardNumber(e.target.value.replace(/[^\d]/g, ''))}
            handleExpiryMonthChange={(e) => setExpiryMonth(e.target.value.replace(/[^\d]/g, ''))}
            handleExpiryYearChange={(e) => setExpiryYear(e.target.value.replace(/[^\d]/g, ''))}
            handleCvvChange={(e) => setCvv(e.target.value.replace(/[^\d]/g, ''))}
            handleCardHolderNameChange={(e) => setCardHolderName(e.target.value)}
            setRecurring={setRecurring}
            handleSetRecurringChange={setSetRecurring}
            submitPaymentRequest={submitPaymentRequest}
            balanceFormatted={balanceFormatted}
        />,
        <SubmittedRequest key="SubmittedRequest" paymentMethod={paymentMethod} serverResponse={serverResponse} seconds_left={seconds_left}/>,
        <VerifyRequest key="VerifyRequest" serverResponse={serverResponse} onCancel={() => handleCloseDialog()} onRetry={() => verifyPayment(serverResponse)}/>,
        <ReceivedFailure key="ReceivedFailure" serverResponse={serverResponse}/>,
        <ReceivedSuccess key="ReceivedSuccess" serverResponse={serverResponse} onClose={() => {
            setIsPaymentLoading(false);
            handleCloseDialog();
        }}/>,
        <ThreeDsFrame key="ThreeDsFrame" threeDsInitUrl={threeDsInitUrl}/>,
    ]

    function displayCurrentState(paymentStage, response) {

        // //console.log("new disps" + paymentStage)
        switch (paymentStage) {
            case 'SUBMITTED_REQUEST': {
                setServerResponse(response);
                setActiveView(1)
                break;
            }
            case 'VERIFY_REQUEST': {
                setServerResponse(response);
                setActiveView(2)
                // setServerResponse(response);
                break;
            }
            case 'RECEIVED_FAILURE': {
                setServerResponse(response);
                setActiveView(3)
                break;
            }
            case 'RECEIVED_SUCCESS': {
                setServerResponse(response);
                setActiveView(4)
                break;
            }
            case 'THREE_DS_FRAME': {
                setActiveView(5)
                break;
            }
            default: {
                setActiveView(0)
                break;
            }
        }


    }


    useMountEffect(() => {
        userProfile = (StorageHelper.get('userProfile'));
        displayCurrentState("", null)
    }, []);

    // Listens for the postMessage the backend sends once
    // iVeri's 3-D Secure ceremony (running inside the iframe below) has finished and the payment
    // has been completed server-side.
    useEffect(() => {
        const handleThreeDsMessage = (event) => {
            if (event.origin !== DOVES_API_ORIGIN) {
                return;
            }
            const data = event.data;
            if (data?.type !== 'VISA_PAYMENT_SUCCESS') {
                return;
            }

            setIsPaymentLoading(false);
            displayCurrentState("RECEIVED_SUCCESS", {responseBody: { paymentStatus: 'PAID', paymentReference: data.reference }});
        };

        window.addEventListener('message', handleThreeDsMessage);
        return () => window.removeEventListener('message', handleThreeDsMessage);
    }, []);







    const submitPaymentRequestToServer = async () => {

        try {
            userProfile = (StorageHelper.get('userProfile'));
            const payload = {
                "operation": "make-payment",
                "requestBody": {
                    "policyNumber": policyNumber,
                    "productName": "payment for policy number " + policyNumber,
                    "productID": userProfile.userId,
                    "notes": "payment for policy number " + policyNumber,
                    "userId": userProfile.userId,
                    "paymentMethod": paymentMethod.toLowerCase(),
                    "mobileNumber": phoneNumber,
                    "payerName": userProfile.firstName + " " + userProfile.lastName,
                    "billingAddress": userProfile.firstName + " " + userProfile.lastName,
                    "emailAddress": userProfile.emailAddress,
                    "amount": amount

                }
            }

            await apiClient.post('payment/ecocash', payload, {
                headers: {
                    Authorization: 'Bearer ' + StorageHelper.get('token'),
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    setIsPaymentLoading(true);
                    startCountDown(30, true, setSeconds_left, response.data);
                    displayCurrentState("SUBMITTED_REQUEST", response.data);
                } else {
                    setIsPaymentLoading(false);
                    const failureMessage = response.data.message || 'Payment submission failed';
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Payment Failed',
                            detail: failureMessage,
                            life: 5000
                        });
                    }
                }
            });

        } catch (error) {
            setIsPaymentLoading(false);
            const errMsg = error.response?.data?.message || error.message || 'An error occurred';
            if (toast.current) {
                toast.current.show({severity: 'error', summary: 'Payment Error', detail: errMsg, life: 5000});
            }
            console.error('Error fetching balance details:', error);
        }
    };

    const submitCardPaymentRequestToServer = async () => {
        try {
            // First verify the policy and get the usual premium
            const response = await apiClient.get('user/verify-policy', {
                params: { identifier: policyNumber.trim() },
                headers: {
                    Authorization: 'Bearer ' + StorageHelper.get('token')
                }
            });
            
            if (response.data.status !== 'SUCCESS') {
                throw new Error(response.data.message || 'Policy not found');
            }
            
            const v = response.data.responseBody;
            const usualPremium = v.usualPremium || 0;

            const iframeUrl = `${DOVES_API_BASE}/visa-payment.html?policyNumber=${v.policyNumber}&premium=${usualPremium}&recurring=${setRecurring}`;
            setThreeDsInitUrl(iframeUrl);
            displayCurrentState("THREE_DS_FRAME", null);
            // Open the secure payment page automatically as soon as the user confirms --
            // no longer an optional fallback the user has to remember to click.
            window.open(iframeUrl, '_blank');

        } catch (error) {
            setIsPaymentLoading(false);
            const errMsg = error.response?.data?.message || error.message || 'An error occurred';
            displayCurrentState("RECEIVED_FAILURE", { message: errMsg });
        }
    };

    const handleCloseDialog = () => {
        setIsPaymentDialogVisible(false);
        setActiveView(0)
        setThreeDsInitUrl(null);
    }

    const verifyPayment = async (responseData) => {

        try {
            //console.log("POLLING TRANSACTION " + responseData.responseBody.paymentReference);
            await apiClient.get('payment/verifyPayment/' + responseData.responseBody.paymentReference, {
                headers: {
                    Authorization: 'Bearer ' + (StorageHelper.get('token'))
                }
            }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    //console.log("verificatrion response")
                    //console.log(response.data.responseBody)
                    switch (response.data.responseBody.paymentStatus) {
                        case 'AWAITING DELIVERY':
                        case 'PAID':
                        case 'DELIVERED': {
                            //console.log(response);
                            setIsPaymentLoading(false)
                            displayCurrentState("RECEIVED_SUCCESS", response.data.responseBody)
                            break;
                        }
                        default: {
                            setIsPaymentLoading(false)
                            setServerResponse(response.data);
                            displayCurrentState("VERIFY_REQUEST", response.data)
                            // displayCurrentState("RECEIVED_FAILURE", response.data)
                            //console.log(displayCurrentState)
                            //console.log("CHANGED THE DISPLAY")
                            break;
                        }
                    }
                } else {
                    setIsPaymentLoading(false);
                    const failureMessage = response.data.message || 'Payment verification failed';
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Verification Failed',
                            detail: failureMessage,
                            life: 5000
                        });
                    }
                }
            });

        } catch (error) {
            setIsPaymentLoading(false);
            const errMsg = error.response?.data?.message || error.message || 'An error occurred';
            if (toast.current) {
                toast.current.show({severity: 'error', summary: 'Verification Error', detail: errMsg, life: 5000});
            }
            console.error('Error fetching balance details:', error);
        }
    };


    function startCountDown(seconds, isStartdownActive, setSeconds_left, responseData) {
        //console.log("Starting countdown..." + responseData);

        const interval = setInterval(() => {
            // setSeconds_left((prevSecond) => (prevSecond === seconds ? 0 : prevSecond - 1));
            if (seconds > 0 && isStartdownActive) {
                //console.log("Countdown:", seconds);
                seconds--; // Decrement the seconds
                setSeconds_left(seconds);
            } else if (seconds === 0) {
                verifyPayment(responseData);
                //console.log("Countdown finished.");
                clearInterval(interval); // Stop the countdown
                // Perform actions when the countdown is finished.
            }
        }, 1000);
    }


    const confirm = () => {
        const modal = document.getElementById('payment_confirm_modal');
        if (modal) modal.showModal();
    };

    return (
        <>
            <AppCard headerImg={paymentImage} className="h-full flex flex-col"
                     bodyClassName="flex-1 flex flex-col justify-around">
                <div className="w-full flex flex-col justify-around flex-1 py-2">
                    <div>
                        <div className="mb-2">
                            <span
                                className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Payments</span>
                            <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Make
                                Payments</h2>
                            <p className="text-sm text-base-content/70">Make payments to your policy and stay up to
                                date. All payments are in USD.</p>
                        </div>

                        <div className="flex flex-col items-start gap-4 my-2">
                            <Button text outlined className="p-0 border-none hover:bg-transparent"
                                    onClick={() => setIsPaymentDialogVisible(true)}>
                                <img alt="logo" src={PaynowButton}
                                     className="h-[4rem] w-auto cursor-pointer transition-transform hover:scale-105"/>
                            </Button>
                            <div>
                                <img
                                    src={PaynowBanner}
                                    alt="PayNow Banner"
                                    className="w-[280px] max-w-full h-auto object-contain"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="divider text-base-content/40 text-sm font-bold my-2">OR</div>

                    <div
                        className="bg-base-200 rounded-2xl p-5 border border-base-300 transition-all hover:border-primary/30">
                        <div
                            className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
                            <div className="bg-primary/10 p-4 rounded-full text-primary flex-shrink-0">
                                <i className="pi pi-calendar-plus text-2xl"></i>
                            </div>
                            <div className="flex-1">
                                <h3 className="font-bold text-base-content text-lg mb-1">Automate Your Payments</h3>
                                <p className="text-sm text-base-content/70 mb-4">
                                    Set up recurring payments so you never miss a premium.
                                </p>
                                <button
                                    className="btn btn-primary btn-sm rounded-full px-6 w-full sm:w-auto"
                                    onClick={() => setIsRecurringDialogVisible(true)}
                                >
                                    Manage Recurring Payments
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </AppCard>

            <Dialog className="dl-dialog" header="Make Payment " visible={isPaymentDialogVisible} maximizable
                    style={{width: '50vw', height: '40vw'}} onHide={() => setisPaymentDialogVisibleCheck(false)}>
                <Toast ref={toast}/>

                <Messages ref={msgs}/>
                {React.cloneElement(viewList[activeView])}
            </Dialog>

            <RecurringPaymentsDialog
                visible={isRecurringDialogVisible}
                onHide={() => setIsRecurringDialogVisible(false)}
                policyNumber={policyNumber}
            />

            <AppConfirmDialog
                id="payment_confirm_modal"
                title="Confirm Payment Details"
                message="Please double-check your payment information. Are you sure you want to securely submit this payment?"
                onConfirm={() => {
                    paymentMethod === "Pay with Visa Card" ? submitCardPaymentRequestToServer() : submitPaymentRequestToServer();
                }}
                confirmStyle="btn-primary text-white border-none"
                cancelStyle="btn-outline"
            />
        </>
    );
}

export default MakePayment;
